import {BrandColors} from "../palettes/types";
import { alpha } from '@mui/material/styles';

const buttonTokens  = (brandColors: BrandColors) => ({
    // filled
    primary: {
        bg:               brandColors.primary.main,
        color:            brandColors.primary.contrastText,
        border:           brandColors.primary.main,

        hoverBg:          brandColors.primary.dark,
        hoverBorder:      brandColors.primary.dark,

        activeBg:         brandColors.primary.dark,
        activeBorder:     brandColors.primary.dark,

        focusRing:        brandColors.action.selected,
        focusRingShadow:  alpha(brandColors.action.selected, 0.35),

        disabledBg:       brandColors.primary.light,
        disabledColor:    brandColors.primary.contrastText,
        disabledBorder:   brandColors.primary.light,
    },

    // outlined
    secondary: {
        bg:               brandColors.background.paper,
        color:            brandColors.text.primary,
        border:           brandColors.dividers.default,

        hoverBg:          brandColors.action.hoveredBackground,
        hoverColor:       brandColors.primary.dark,
        hoverBorder:      brandColors.dividers.focus,

        activeBg:         brandColors.action.hoveredBackground,
        activeColor:      brandColors.primary.dark,
        activeBorder:     brandColors.dividers.focus,

        focusRing:        brandColors.action.hoveredBackground,
        focusRingShadow:  alpha(brandColors.action.hoveredBackground, 0.28),

        disabledBg:       brandColors.background.default,
        disabledColor:    brandColors.text.disabled,
        disabledBorder:   brandColors.dividers.subtle,
    },

    // ghost
    ternary: {
        bg:               'transparent',
        color:            brandColors.text.secondary,
        border:           'transparent',

        hoverBg:          brandColors.action.hoveredBackground,
        hoverColor:       brandColors.text.primary,
        hoverBorder:      'transparent',

        activeBg:         brandColors.dividers.light,
        activeColor:      brandColors.text.primary,
        activeBorder:     'transparent',

        focusRing:        brandColors.dividers.focus,
        focusRingShadow:  alpha(brandColors.dividers.focus, 0.22),

        disabledBg:       'transparent',
        disabledColor:    brandColors.text.disabled,
        disabledBorder:   'transparent',
    },

    // inline
    link: {
        color:          brandColors.link.main,
        hoverColor:     brandColors.link.dark,
        activeColor:    brandColors.link.main,
        visitedColor:   brandColors.link.dark,
        focusRing:      brandColors.link.dark,
        disabledColor:  brandColors.link.light,
    },

}) as const;

export const buildButtonTokensTheme = (brandColors: BrandColors) => ({
    buttonTokens: buttonTokens(brandColors),
} satisfies import('@mui/material/styles').ThemeOptions);
